import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/services/emergency-treatment/EmergencyTreatment.tsx");
